import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';

const Content = () => {
  return (
    <Box>
      <Box>
        <Typography component={'p'} marginBottom={2}>
          In Marketing We Trust (“us”, “we”, or “our”) operates the http://www.checkmyanalytics.com/ website (the “Service”).
        </Typography>
        <Typography component={'p'} marginBottom={2}>
          This page informs you of our policies regarding the collection, use and disclosure of Personal Information when you use our Service.
        </Typography>
        <Typography component={'p'} marginBottom={2}>
          We will not use or share your information with anyone except as described in this Privacy Policy.
        </Typography>
        <Typography component={'p'} marginBottom={2}>
          <strong>We use your Personal Information for providing and improving the Service. By using the Service, you agree to the collection and use of information in accordance with this policy.</strong>&nbsp;Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible at http://www.checkmyanalytics.com/
        </Typography>
      </Box>
      <Box>
        <Typography
          variant={'h4'}
          fontSize={{ xs: 26, sm: 30, md: 34 }}
          fontWeight={600}
          gutterBottom
          marginTop={4}
        >
          Information Collection And Use
        </Typography>
        <Typography component={'p'} marginBottom={2}>
          While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to, your email address (“Personal Information”).
        </Typography>
        <Typography component={'p'} marginBottom={2}>
          The purpose for which we collect personal information is to provide you with the best service experience possible on the Service and for our internal business purposes that form part of normal business practices. Some provision of personal information is optional. However, if you do not provide us with certain types of personal information, you may be unable to enjoy the full functionality of the Service.
        </Typography>
        <Box>
          <Typography
            variant={'h5'}
            fontSize={{ xs: 20, sm: 24 }}
            fontWeight={600}
            gutterBottom
            marginTop={4}
          >
            Log Data
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            We collect information that your browser sends whenever you visit our Service (“Log Data”). This Log Data may include information such as your computer’s Internet Protocol (“IP”) address, browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages and other statistics.
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            In addition, we may use third party services such as Google Analytics that collect, monitor and analyze this type of information in order to increase our Service’s functionality. These third party service providers have their own privacy policies addressing how they use such information.
          </Typography>
          <Typography
            variant={'h5'}
            fontSize={{ xs: 20, sm: 24 }}
            fontWeight={600}
            gutterBottom
            marginTop={4}
          >
            Cookies
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your computer’s hard drive.
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            We use “cookies” to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.
          </Typography>
          <Typography
            variant={'h5'}
            fontSize={{ xs: 20, sm: 24 }}
            fontWeight={600}
            gutterBottom
            marginTop={4}
          >
            Service Providers
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            We may employ third party companies and individuals to facilitate our Service, to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used.
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            These third parties have access to your Personal Information only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
          </Typography>
          <Typography
            variant={'h5'}
            fontWeight={600}
            fontSize={{ xs: 20, sm: 24 }}
            gutterBottom
            marginTop={4}
          >
            Security
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.
          </Typography>
          <Typography
            variant={'h5'}
            fontWeight={600}
            fontSize={{ xs: 20, sm: 24 }}
            gutterBottom
            marginTop={4}
          >
            International Transfer
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            Your information, including Personal Information, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            If you are located outside Australia and choose to provide information to us, please note that we transfer the information, including Personal Information, to Australia and process it there.
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.
          </Typography>
        </Box>
        <Box>
          <Typography
            variant={'h4'}
            fontSize={{ xs: 26, sm: 30, md: 34 }}
            fontWeight={600}
            gutterBottom
            marginTop={4}
          >Access and Correction
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            Australian Privacy Principle 6 of the Privacy Act 1988 (Cth) allows you to get access to, and correct, the personal information we hold about you in certain circumstances. If you would like to obtain such access, please contact us on the details set out above.
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            Please note that the access and correction requirements under this Privacy Policy operates alongside and do not replace other informal or legal procedures by which an individual can be provided access to, or correction of, their personal information, including the requirements under the Freedom of Information Act 1982 (Cth).
          </Typography>
        </Box>
        <Box>
          <Typography
            variant={'h4'}
            fontSize={{ xs: 26, sm: 30, md: 34 }}
            fontWeight={600}
            gutterBottom
            marginTop={4}
          >Complaints
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            Australian Privacy Principle 1 of the Privacy Act 1988 (Cth) allows you to make a complaint about any alleged breaches of privacy. In order to lodge a complaint with us, please contact us using the details above with the following information:
          </Typography>
          <Typography component={'ol'} marginBottom={2}>
            <li>Your name and address;</li>
            <li>Details of the alleged breach of privacy; and</li>
            <li>URL link to the alleged breach of privacy (if applicable).</li>
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            Please allow us 30 days to investigate your complaint, after which we will contact you immediately to resolve the issue.
          </Typography>
        </Box>
        <Box>
          <Typography
            variant={'h4'}
            fontSize={{ xs: 26, sm: 30, md: 34 }}
            fontWeight={600}
            gutterBottom
            marginTop={4}
          >Retention of Information
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            We retain information for as long as required, allowed or we believe it useful, but do not undertake retention obligations. We may dispose of information in our discretion without notice, subject to applicable law that specifically requires the handling or retention of information. You must keep your own, separate back-up records.
          </Typography>
          <Typography
            variant={'h5'}
            fontSize={{ xs: 20, sm: 24 }}
            fontWeight={600}
            gutterBottom
            marginTop={4}
          >Links To Other Sites
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party’s site. We strongly advise you to review the Privacy Policy of every site you visit.
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            We have no control over, and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
          </Typography>
          <Typography
            variant={'h5'}
            fontSize={{ xs: 20, sm: 24 }}
            fontWeight={600}
            gutterBottom
            marginTop={4}
          >Children’s Privacy
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            Our Service does not address anyone under the age of 18 (“Children”).
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            We do not knowingly collect personally identifiable information from children under 18. If you are a parent or guardian and you are aware that your Children has provided us with Personal Information, please contact us. If we become aware that we have collected Personal Information from children under 18 without verification of parental consent, we take steps to remove that information from our servers or replace it with the Personal Information of the Children’s parent or guardian.
          </Typography>
        </Box>
        <Box>
          <Typography
            variant={'h4'}
            fontSize={{ xs: 26, sm: 30, md: 34 }}
            fontWeight={600}
            gutterBottom
            marginTop={4}
          >Changes To This Privacy Policy
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website.
          </Typography>
        </Box>
        <Box>
          <Typography
            variant={'h4'}
            fontSize={{ xs: 26, sm: 30, md: 34 }}
            fontWeight={600}
            gutterBottom
            marginTop={4}
          >Consent
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            You warrant that you are able to give consents under Australian Law or, in the event that you do not have the capacity to give consent, you warrant that your guardian or attorney is able to give any consent required under this Privacy Policy on your behalf.
          </Typography>
          <Typography component={'p'} marginBottom={2}>
            You hereby expressly and voluntarily grant your informed consent to us to deal with your personal information in accordance with the terms and conditions of this Privacy Policy. Should you retract your consent, please contact us. If you retract your consent, you acknowledge and agree that failure to provide certain types of personal information may not give you access to the full functionality of the Service.
          </Typography>
        </Box>
        <Box>
          <Typography
            variant={'h4'}
            fontSize={{ xs: 26, sm: 30, md: 34 }}
            fontWeight={600}
            gutterBottom
            marginTop={4}
          >Contact Us
          </Typography>
          <Typography component={'p'}>
            If you have any questions about this Privacy Policy, please <Link component="a" to="/contact">contact us</Link>.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Content;
